<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 200"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('form_title_sku') || '采购需求sku明细' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openChooseAmzSku()"
              v-if="allow('A')"
              v-show="amzPurchaseDemandCode && !disabled"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:expandContent="{row}">
        <StoreTable
          class="m-2"
          :amzPurchaseDemandSkuCode="row.amzPurchaseDemandSkuCode"
          :amzPurchaseDemandCode="amzPurchaseDemandCode"
          :disabled="disabled"
        />
      </template>
      <template v-slot:goodsName="{row}">
        <span>{{ row.goodsName + '' + row.goodsNameEn }}</span>
      </template>
      <template v-slot:opt="{row}">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.amzPurchaseDemandSkuCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>

    <ChooseAmzSku
      :visible.sync="chooseAmzSkuVisible"
      url="/ecom/amz/sku/listByDemand"
      :amzSkuStatus="['Y']"
      :extra-data="{ amzPurchaseDemandCode }"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseAmzSkuConfirm"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import StoreTable from '../store-table'
import ChooseAmzSku from '@/views/ecom/components/choose-amz-sku'
export default {
  mixins: [EditLoading, TableAutoHeight],
  components: {StoreTable, ChooseAmzSku},
  props: {
    disabled: {type: Boolean, default: false},
    amzPurchaseDemandCode: {type: String, default: ''},
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
      },

      tableColumns: tableColumns(this),

      chooseAmzSkuVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.amzPurchaseDemandCode) return
      this.loading = true
      this.$api
        .ecomAmzPurchaseDemandSkuListApi({
          amzPurchaseDemandCode: this.amzPurchaseDemandCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openChooseAmzSku() {
      this.chooseAmzSkuVisible = true
    },
    chooseAmzSkuConfirm(data) {
      if (data.length <= 0) return
      const listCode = data.map((item) => {
        return item.amzSkuCode
      })
      this.loadingOpen()
      this.$api
        .ecomAmzPurchaseDemandSkuSaveApi({
          amzPurchaseDemandCode: this.amzPurchaseDemandCode,
          listCode: listCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzPurchaseDemandSkuDelApi({amzPurchaseDemandSkuCode: code})
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
          })
      })
    },
  },
}
</script>
